export default "__VITE_ASSET__Bwv7VWBh__";